<div class="eventq-camera-pages" role="navigation" aria-label="Camera pages">
  <button
    type="button"
    class="eventq-camera-pages__nav"
    [disabled]="page() <= 1"
    aria-label="Previous page"
    (click)="goPrev()"
  >
    <mat-icon aria-hidden="true">chevron_left</mat-icon>
  </button>

  @for (item of items(); track $index) {
    @if (item === 'ellipsis') {
      <span class="eventq-camera-pages__ellipsis" aria-hidden="true">...</span>
    } @else {
      <button
        type="button"
        class="eventq-camera-pages__page"
        [class.eventq-camera-pages__page--active]="item === page()"
        [attr.aria-current]="item === page() ? 'page' : null"
        [attr.aria-label]="'Page ' + item"
        (click)="goTo(item)"
      >
        {{ item }}
      </button>
    }
  }

  <button
    type="button"
    class="eventq-camera-pages__nav"
    [disabled]="page() >= totalPages()"
    aria-label="Next page"
    (click)="goNext()"
  >
    <mat-icon aria-hidden="true">chevron_right</mat-icon>
  </button>
</div>
